import app from 'flarum/forum/app';
import ItemList from 'flarum/common/utils/ItemList';
import { childrenOf } from '../../common/utils/linkHierarchy';
import LinkHeading from '../components/LinkHeading';
import LinkItem from '../components/LinkItem';
import { isLinkActive } from './linkTarget';
export function containsActiveLink(parent) {
  return isLinkActive(parent) || childrenOf(app.store.all('links'), parent).some(isLinkActive);
}
function entry(link) {
  return link.isLabel() ? m(LinkHeading, {
    link: link
  }) : m(LinkItem, {
    link: link,
    inDropdown: true
  });
}

/**
 * A group's menu leads with the group itself. Core relies on that first entry:
 * a split dropdown hides it beside its own button, and the header's overflow
 * menu shows it as the title of the group.
 */
export function linkGroupItems(parent) {
  const items = new ItemList();
  items.add(`link${parent.id()}`, entry(parent), 100);
  childrenOf(app.store.all('links'), parent).forEach((child, index) => {
    items.add(`link${parent.id()}-${child.id()}`, entry(child), -index);
  });
  return items;
}
flarum.reg.add('fof-links', 'forum/utils/linkGroup', { containsActiveLink: containsActiveLink,linkGroupItems: linkGroupItems, });